import React, { useEffect, useState } from "react";
 
import { deleteRoom, getRoomsForHostel } from "../../../services/OrganisationServices/hostelRoomServices";
import MasterTable from "../../../views/dashboard/widget/MasterTabel";
import { useParams } from "react-router-dom";
import { useGlobalState } from "../../../services/hostelConst.js";
import { getHostelComplainsList } from "../../../services/OrganisationServices/hostelManagmentService";
const ComplainsTable = () => {
  const {  toggleHostelMenu } = useGlobalState();
  var { id } = useParams();

  useEffect(() => {
    toggleHostelMenu(true);

    return () => {};
  }, []);

  return (
    <div>
      <MasterTable
        getTableData={getHostelComplainsList}
        tab1={"Hostel"}
        tab2={"Complains"}
        hostelId={id}
        actions={
          {
            status: true,
            edit: true,
            delete: true,
          }
        }
        deleteRow={deleteRoom}
        externalPermis={
          {
            POST:0,
            GET: 1,
            UPDATE:1
          }
        }
      />
    </div>
  );
};

export default ComplainsTable;
